import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscX = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.64 63.64" width="100%" height="100%" {...props}>
    <g data-name="Layer 2">
      <path
        fill="currentColor"
        d="M7.07 0 0 7.07l24.75 24.75L0 56.57l7.07 7.07 24.75-24.75 24.75 24.75 7.07-7.07-24.75-24.75L63.64 7.07 56.57 0 31.82 24.75Z"
        data-name="Layer 1"
      />
    </g>
  </svg>
);
